const entryCreate = require('./contentful/entry-create');
const EntryService = require('../services/EntryService').default;
const getSpace = require('./contentful/get-space');
const transformer = require('./transformers/modelPage');
const linkResolve = require('./contentful/link-resolve');
const block = require('./block');
const entryUpdate = require('./contentful/entry-update');
const getEntry = require('./contentful/entry-get');
const update = require('immutability-helper');

let entryService = null;

const gettingEntryService = () => {
  if (!entryService) {
    entryService = getSpace().then((space) => {
      return new EntryService(space, transformer);
    });
  }

  return entryService;
};

const createModelPage = (space, page, depth) => {
  const data = transformer.internalToContentful(page);
  return entryCreate(space, 'modelPage', data).then((entry) => {
    return entry;
  }).then((entry) => {
    const data = entry.toPlainObject();
    return linkResolve(space, data, depth);
  }).then((data) => {
    return transformer.contentfulToInternal(data);
  });
};

module.exports = {
  getById(...parameters) {
    return gettingEntryService().then((service) => service.getById(...parameters));
  },

  new(page, depth = 0) {
    return getSpace().then((space) => {
      return createModelPage(space, page, depth);
    });
  },

  save(page, depth = 0) {
    return getSpace().then((space) => {
      return getEntry(space, page.id).then((entry) => {
        const data = entry.toPlainObject();
        let currentBodytextLinks = [];

        if (data.fields.bodytext && data.fields.bodytext['nb-NO']) {
          currentBodytextLinks = data.fields.bodytext['nb-NO'];
        }

        return block.saveBlockArray(currentBodytextLinks, page.bodytext, false).then((newBodytext) => {
          const newPage = update(page, {
            bodytext: {
              $set: newBodytext
            }
          });

          const data = transformer.internalToContentful(newPage);
          return entryUpdate(entry, data);
        }).then((entry) => {
          const data = entry.toPlainObject();
          return linkResolve(space, data, depth);
        }).then((data) => {
          return transformer.contentfulToInternal(data);
        });
      });
    });
  },

  publish(...parameters) {
    return gettingEntryService().then((service) => service.publish(...parameters));
  },

  publishWithBlocks(page, depth) {
    const bodytextIdsToPublish = page.bodytext.reduce((ids, md) => {
      if (!md.published || md.updated) {
        ids.push(md.id);
      }

      return ids;
    }, []);

    if (!bodytextIdsToPublish.length) {
      return gettingEntryService().then((service) => service.publish(page.id, depth));
    }

    return block.publishBlocks(bodytextIdsToPublish).then(() => {
      return gettingEntryService().then((service) => service.publish(page.id, depth));
    });
  },

  unpublish(...parameters) {
    return gettingEntryService().then((service) => service.unpublish(...parameters));
  },

  archive(...parameters) {
    return gettingEntryService().then((service) => service.archive(...parameters));
  },

  unarchive(...parameters) {
    return gettingEntryService().then((service) => service.unarchive(...parameters));
  }
};
